import { For } from "solid-js";
export type Props = {
  items: { name?: string; email?: string; role?: string; image: string }[];
};
export default function (props: Props) {
  return (
    <div class="flex flex-row w-full">
      <For each={props?.items}>
        {(member, index) => {
          const left_shift = 20;
          return (
            <div
              style={{
                transform: `translateX(-${index() * left_shift}px)`,
                "z-index": `${index()}`,
              }}
              class="flex w-44px h-44px overflow-hidden rounded-full  border-2 border-solid border-border-input"
            >
              <img
                class="w-full h-full rounded-full"
                src={member?.image ?? "/images/placeholders/person.png"}
                alt={`img-${index}`}
              />
            </div>
          );
        }}
      </For>
    </div>
  );
}
